import {RateSummaryAttributes} from "typing/dto";

export const getMockRateSummary = (unitId: number): RateSummaryAttributes => ({
    unit_id: unitId,
    summary:
        "With a current occupancy rate of 12.79% and monthly revenue of $12,450, this property is performing well below market expectations. The price to value ratio of 135.22% suggests room for pricing optimization.",
    keyActions: [
        "Adjust weekday pricing",
        "Implement seasonal rate variations to better align with market demand while maintaining owner's revenue preference",
    ],
    rateInsights: [
        "Revenue 20% above market average",
        "Consistent month-over-month growth",
        "Strong performance in premium segment",
        "Higher RevPAR than 85% of comparable properties",
    ],
    revenueData: [
        {date: "Jan", thisProperty: 5000, similarProperties: 4200},
        {date: "Feb", thisProperty: 4150, similarProperties: 4500},
        {date: "Mar", thisProperty: 5500, similarProperties: 4800},
        {date: "Apr", thisProperty: 6200, similarProperties: 5100},
        {date: "May", thisProperty: 7000, similarProperties: 5400},
    ],
    needsAttentionItems: [
        {
            title: "Increase weekend rates by 15-20%",
            description:
                "Current ADR is 12% below market average for similar properties in your area. Recommend increasing weekend rates by 15-20% to match competitor pricing.",
            extraInfo:
                "Detailed analysis shows that weekend rates in your area have increased by 25% over the past year. Your property has maintained the same rates, resulting in a significant revenue gap.",
            confidence: 95,
        },
        {
            title: "Adjust seasonal pricing strategy",
            description:
                "Summer rates are 8% below market average. Consider adjusting seasonal pricing to better align with market trends and demand patterns.",
            extraInfo:
                "Market data indicates that summer demand has increased by 15% in your area. Current pricing strategy may be leaving revenue on the table during peak season.",
            confidence: 88,
        },
    ],
    opportunitiesItems: [
        {
            title: "Reduce weekday rates by 20% to boost occupancy",
            description: "Current ADR is 15-20% above market average for similar properties in your area. Expected 15-20% occupancy increase.",
            impact: "Potential 15-20% occupancy increase",
            confidence: 92,
            moreInfoLink: "#",
        },
        {
            title: "Implement dynamic pricing for peak weekend periods",
            description: "Estimated $3,200 monthly revenue increase | 88% confidence",
            impact: "Estimated $3,200 monthly revenue increase",
            confidence: 88,
            moreInfoLink: "#",
        },
        {
            title: "Install premium hot tub to justify premium rates",
            description: "Expected $2,250 monthly revenue increase | 85% confidence",
            impact: "Expected $2,250 monthly revenue increase",
            confidence: 85,
            moreInfoLink: "#",
        },
    ],
    snapshotMetrics: [
        {
            value: "Negative",
            status: "negative",
            subtitle: "Needs immediate attention",
        },
        {
            value: 88292,
            change: {value: 12.3, isPositive: true},
        },
        {
            value: 245,
            change: {value: 5.2, isPositive: false},
        },
        {
            value: 78,
            change: {value: 3.5, isPositive: false},
        },
    ],
});
